import { Component } from '@angular/core';
import { TranslateHelper } from '../../../helpers/injector.helper';
import { ConfigService } from '../../../services/config.service';

@Component({
    selector: 'documentation-edit-dialog',
    templateUrl: './documentation.edit.dialog.html'
})
export class DocumentationEditDialog {

    DocumentationSettings;
    ActualText;
    AllLanguages = [];  

    constructor(private service: ConfigService) {
    }

    ngOnInit(): void {
        this.service.GetSelectedLanguages().subscribe(x => {
            const allLanguages = [];
            if (this.DocumentationSettings) {
                allLanguages.push({
                    LCID: -1,
                    Caption: TranslateHelper.TranslatorInstance.instant('@@Default'),
                    Text: this.DocumentationSettings.DefaultText
                });
                if (x) {
                    x.forEach(lang => {
                        const transEntry = this.DocumentationSettings.TranslatedTexts.find(y => y.LCID == lang.LCID);
                        if (transEntry) {
                            allLanguages.push({
                                LCID: lang.LCID,
                                Caption: lang.Caption,
                                Text: transEntry.Text
                            });
                        } else {
                            allLanguages.push({
                                LCID: lang.LCID,
                                Caption: lang.Caption,
                                Text: ''
                            });
                        }
                    });
                }
            } else {
                allLanguages.push({
                    LCID: -1,
                    Caption: TranslateHelper.TranslatorInstance.instant('@@Default'),
                    Text: ''
                });
                if (x) {
                    x.forEach(lang => {
                        allLanguages.push({
                            LCID: lang.LCID,
                            Caption: lang.Caption,
                            Text: ''
                        });
                    });
                }
            }
            this.AllLanguages = allLanguages;
            this.ActualText = allLanguages[0];
        });
    }

    Initialize(args) {
        if (args) {
            this.DocumentationSettings = args;
        }
    }

    GetDialogResult() {
        const retVal = {
            DefaultText: '',
            TranslatedTexts: []
        };
        this.AllLanguages.forEach(lang => {
            if (lang.LCID == -1) {
                retVal.DefaultText = lang.Text;
            } else if (lang.Text) {
                retVal.TranslatedTexts.push({
                    LCID: lang.LCID,
                    Text: lang.Text
                });
            }
        });
        return retVal;
    }
}
